<template>
<v-btn :color="color">
  <v-progress-circular size="30" width="3" indeterminate />
  {{text}}
</v-btn>
</template>
<script>
export default {
  props: ['color', 'text'],
};
</script>
